import { Big } from 'big.js';
export class InsureCalc {
    constructor(ConfigIn) {
        this.digits = 15;
        this.config = ConfigIn;
    }
    getQuote(request) {
        const insuranceResult = this.CalculateInsurance(request);
        let payout = insuranceResult.map(data => { var _a; return (_a = data.finalComp) !== null && _a !== void 0 ? _a : 0; });
        if (payout.length == 0) {
            payout = [0]; //Did this to provide a uniform response. The array index = num of losses
        }
        const quote = {
            payout: [],
            meta: { moneyBackBoost: false }
        };
        const moneyBackBoostResult = this.CalculateMoneyBackBoost(request);
        if (moneyBackBoostResult > 0) {
            if (payout.length > 1) {
                if (moneyBackBoostResult > payout[1]) {
                    payout[1] = moneyBackBoostResult;
                    quote.meta.moneyBackBoost = true;
                }
            }
            else {
                payout.push(moneyBackBoostResult);
                quote.meta.moneyBackBoost = true;
            }
        }
        for (var p = 0; p < payout.length; p++) {
            payout[p] = new Big(payout[p]).round(2).toNumber();
            if (this.config.maxPayoutAmount != null
                && this.config.maxPayoutAmount > 0
                && payout[p] > this.config.maxPayoutAmount) {
                payout[p] = this.config.maxPayoutAmount;
            }
            if (!(payout[p] > 0 && payout[p] < request.wageredAmount)) {
                quote.payout.push(payout[p]);
            }
        }
        if (this.config.maxPayoutAmount != null && this.config.maxPayoutAmount > 0) {
            for (var p = 0; p < quote.payout.length; p++) {
                if (quote.payout[p] > this.config.maxPayoutAmount) {
                    quote.payout[p] = this.config.maxPayoutAmount;
                }
            }
        }
        if (quote.payout.length > 1 && quote.payout[1] < request.wageredAmount) {
            quote.payout.splice(1, quote.payout.length - 1);
        }
        return quote;
    }
    calcLossProbalities(priceDecimals) {
        // Loop through all the bets in the Betslip
        let lossProbabilities = [];
        for (let i = 0; i < priceDecimals.length; i++) {
            const oddWin = new Big(1 / priceDecimals[i]).round(this.digits); //changed to use price decimal
            const oddLoss = new Big(1).minus(oddWin).round(this.digits);
            if (i === 0) {
                // For the First Bet, the Win and Loss Matrix is variable values
                lossProbabilities = [oddWin.toNumber(), oddLoss.toNumber()];
            }
            else {
                const updatedLossProbabilities = [...lossProbabilities];
                // The Win Matrix is the previous Loss Probability Matrix with the Probability Multiplied by this bet Win Odd
                for (let j = 0; j < lossProbabilities.length; j++) {
                    updatedLossProbabilities[j] = new Big(updatedLossProbabilities[j]).times(oddWin).round(this.digits).toNumber();
                }
                // The Loss Matrix is the previous Loss Probability Matrix with the Probability Multiplied by this bet Loss Odd,
                // and the Number Of Loss counter increased by 1
                for (let j = 0; j < lossProbabilities.length; j++) {
                    const updatedKey = j + 1;
                    if (updatedLossProbabilities[updatedKey]) {
                        var t0 = new Big(updatedLossProbabilities[updatedKey]);
                        var t1 = new Big(lossProbabilities[j]).times(oddLoss);
                        var t2 = t0.add(t1);
                        updatedLossProbabilities[updatedKey] =
                            new Big(updatedLossProbabilities[updatedKey]).add(new Big(lossProbabilities[j]).times(oddLoss)).round(this.digits).toNumber();
                    }
                    else {
                        updatedLossProbabilities[updatedKey] = new Big(lossProbabilities[j]).times(oddLoss).round(this.digits).toNumber();
                    }
                }
                lossProbabilities = updatedLossProbabilities;
            }
        }
        return lossProbabilities;
    }
    getExpectedMargin(ExpectedMarginSplit, BetCount) {
        var _a, _b;
        return (_b = (_a = ExpectedMarginSplit.find(x => x.numberOfBets == BetCount)) === null || _a === void 0 ? void 0 : _a.expectedMargin) !== null && _b !== void 0 ? _b : 0;
    }
    calcAvailComp(WageredAmount, XM, MR, Probability) {
        const dXM = new Big(XM);
        const dWageredAmount = new Big(WageredAmount);
        const dMR = new Big(MR);
        const dProbability = new Big(Probability);
        //return ( (WageredAmount * XM) - (WageredAmount * (XM - (XM * MR)))) / Probability;
        return (dWageredAmount.times(dXM).minus(dWageredAmount.times(dXM.minus(dXM.times(dMR))))).div(dProbability).round(this.digits).toNumber();
    }
    CalculateCompV1(request, dataset, maxNumberOfLosses) {
        let totalExponentialDistribution = 0;
        let totalAvailableComp = 0;
        for (const data of dataset) {
            if (data.probability > 0) {
                data.availComp = this.calcAvailComp(request.wageredAmount, this.getExpectedMargin(this.config.expectedMarginSplit, request.priceDecimals.length), this.config.marginReduction, data.probability);
            }
            if (data.numberOfLosses === 0)
                continue;
            data.reverseRank = Math.abs(data.numberOfLosses - maxNumberOfLosses);
            data.exponentialDistribution = new Big(this.config.compDistributionFactor).pow(data.reverseRank).round(this.digits).toNumber(); // Math.pow(this.config.compDistributionFactor, data.reverseRank);
            totalExponentialDistribution = new Big(totalExponentialDistribution).add(data.exponentialDistribution).round(this.digits).toNumber();
            totalAvailableComp = new Big(totalAvailableComp).add(data.availComp).round(this.digits).toNumber();
        }
        for (const data of dataset) {
            if (data.numberOfLosses === 0)
                continue;
            data.percentageDistribution = new Big(data.exponentialDistribution).div(totalExponentialDistribution).round(4).toNumber();
            data.finalComp = new Big(data.percentageDistribution).times(totalAvailableComp).round(4).toNumber();
        }
    }
    CalculateCompV2(request, dataset) {
        var _a;
        for (const data of dataset) {
            if (data.numberOfLosses === 0)
                continue;
            data.finalComp = new Big(1).div(data.probability).times(request.wageredAmount).times((_a = this.config.compPercentage) !== null && _a !== void 0 ? _a : 0).round(4).toNumber();
        }
    }
    CalculateInsurance(request) {
        const dataset = [];
        const lossProbabilities = this.calcLossProbalities(request.priceDecimals);
        let maxNumberOfLosses = 0;
        for (var i = 0; i < lossProbabilities.length; i++) {
            const lossProbability = lossProbabilities[i];
            const data = {
                numberOfLosses: i,
                probability: lossProbability,
                cumalativeProbability: i === 0 ? lossProbability : new Big(dataset[i - 1].cumalativeProbability).add(lossProbability).round(this.digits).toNumber(),
                availComp: 0,
                finalComp: 0,
                reverseRank: 0,
                exponentialDistribution: 0
            };
            if (data.cumalativeProbability > this.config.cumulativeProbabilityCutOff)
                break;
            dataset.push(data);
            maxNumberOfLosses = data.numberOfLosses;
        }
        if (this.config.calcVersion == 2)
            this.CalculateCompV2(request, dataset);
        else
            this.CalculateCompV1(request, dataset, maxNumberOfLosses);
        return dataset;
    }
    CalculateMoneyBackBoost(request) {
        var _a;
        if (this.config.moneyBackBoost.length > 0 && !((_a = this.config.moneyBackBoostDisabled) !== null && _a !== void 0 ? _a : false)) {
            for (const mbb of this.config.moneyBackBoost.sort((a, b) => b.numberOfSelectionsFrom - a.numberOfSelectionsFrom)) {
                const betCount = request.priceDecimals.filter(x => x >= mbb.minimumOdds).length;
                if (mbb.numberOfSelectionsFrom <= betCount && mbb.numberOfSelectionsTo >= betCount) {
                    return new Big(request.wageredAmount * mbb.betReturned).round(2).toNumber();
                }
            }
        }
        return 0;
    }
}
